import React from 'react';
import { Chip } from '@heroui/react';
import { Typography } from '../../../../components';
import { useTranslations } from '../../../../contexts/translation.context';
import { TransactionData } from '../types';
import { getTransactionStatus } from '../utils';

interface TransactionStatusCellProps {
  transaction: TransactionData;
}

const TransactionStatusCell: React.FC<TransactionStatusCellProps> = ({ transaction }) => {
  const { t } = useTranslations();

  const status = getTransactionStatus(transaction);

  const getStatusConfig = () => {
    switch (status) {
      case 'confirmed':
        return {
          dot: 'bg-success',
          label: t('transactions.status.confirmed'),
        };
      case 'returned':
        return {
          dot: 'bg-danger',
          label: t('transactions.status.returned'),
        };
      case 'pending':
      default:
        return {
          dot: 'bg-neutral-400',
          label: t('transactions.status.pending'),
        };
    }
  };

  const statusConfig = getStatusConfig();

  return (
    <Chip
      className="bg-gray-100 text-gray-900"
      classNames={{
        base: 'h-6 px-2 py-1 gap-1',
      }}
      size="sm"
      startContent={<div className={`w-2 h-2 rounded-full ${statusConfig.dot}`} />}
    >
      <Typography variant="body3" className="text-gray-900">
        {statusConfig.label}
      </Typography>
    </Chip>
  );
};

export default TransactionStatusCell;

